import {
  CatIconShop,
  CatIconEngine,
  CatIconTools,
  CatIconTrash,
  CatIconBox,
  CatIconMenuDots,
  CatIconDashboard2
} from 'components/blocks-components';
import { navigateTo } from '@cat-ecom/common/utils/browserUtils';
import { StatusType } from '../types';
import { LOCATION_HASH_KEY, MY_EQP_SCHEMA } from '../constants';
import { PARTS_DIAGRAM } from 'constants/links';
import styles from './my-equipment-action-menu.module.scss';
import { getGaContext } from './utils';
import { redirectToNewAlpUrl } from '../utils';

export function getActionMenuSchema({
  action,
  equipmentDetails,
  isRequestService,
  isDetailsCard = false,
  actionItems,
  selectedEquipmentIndex = 0,
  isDesktop,
  esiteUrl,
  setModalOptions = null,
  openRSModal,
  editHandler = null,
  clearSelectionHandler = null,
  selectedEquipmentHandler = null,
  redirectOnClick,
  gaContext,
  params,
  router,
  isAssetLandingFeatureFlag
}) {
  const hasSelectedEquipment = selectedEquipmentIndex > -1;
  const isMoreAvailable = actionItems.some(
    (cardAction) => cardAction.id === MY_EQP_SCHEMA.MORE
  );
  const isMultiCard = !isDetailsCard || !isMoreAvailable;

  const catPartsHandler = () => {
    const partsUrl = ` ${esiteUrl}${PARTS_DIAGRAM}`;
    if (isMoreAvailable) {
      navigateTo(partsUrl);
    }
    return redirectOnClick(partsUrl, action.isSelectedEquipment);
  };

  const gaContextText =
    gaContext ?? getGaContext(hasSelectedEquipment, isMoreAvailable);

  const menuActions = {
    VIEW_DASHBOARD: {
      label: MY_EQP_SCHEMA.VIEW_DASHBOARD,
      gaLabel: 'View Dashboard',
      icon: <CatIconDashboard2 size={isDesktop ? 'lg' : null} />,
      classNames: 'text-break u-color--Black',
      onClick: () =>
        redirectToNewAlpUrl(
          router,
          isAssetLandingFeatureFlag,
          params,
          equipmentDetails.seoUrl,
          action.isSelectedEquipment,
          equipmentDetails
        ),
      gaContext: gaContextText,
      displayIcon: isMoreAvailable,
      isActionVisible: true,
      ...action
    },
    SHOP_PARTS: {
      label: MY_EQP_SCHEMA.SHOP_PARTS,
      gaLabel: 'Shop Parts',
      icon: <CatIconShop size="lg" />,
      classNames: 'text-break u-color--Black',
      onClick: () =>
        redirectOnClick(
          `${equipmentDetails.seoUrl}${LOCATION_HASH_KEY.SHOP_PARTS}`,
          action.isSelectedEquipment
        ),
      gaContext: gaContextText,
      displayIcon: isMoreAvailable,
      isActionVisible: true,
      ...action
    },
    CAT_PARTS_DIAGRAM: {
      label: MY_EQP_SCHEMA.CAT_PARTS_DIAGRAM,
      gaLabel: 'Cat Parts Diagram',
      icon: <CatIconEngine size="lg" />,
      classNames: 'text-break u-color--Black',
      onClick: catPartsHandler,
      gaContext: gaContextText,
      displayIcon: isMoreAvailable,
      isActionVisible: true,
      ...action
    },
    REQUEST_SERVICE: {
      label: MY_EQP_SCHEMA.REQUEST_SERVICE,
      gaLabel: 'Request Service',
      icon: <CatIconTools size="lg" />,
      onClick: () => openRSModal(),
      classNames: 'text-break u-color--Black',
      gaContext: gaContextText,
      displayIcon: isDesktop,
      isActionVisible: isRequestService,
      ...action
    },
    ALP_MAINTENANCE_REPAIRS: {
      label: MY_EQP_SCHEMA.ALP_MAINTENANCE_REPAIRS,
      gaLabel: 'Alp Mainteance Repairs',
      icon: <CatIconBox size="lg" />,
      classNames: 'text-break u-color--Black',
      onClick: () =>
        redirectOnClick(
          `${equipmentDetails.seoUrl}${LOCATION_HASH_KEY.MAINTENANCE_REPAIRS}`,
          action.isSelectedEquipment
        ),
      gaContext: gaContextText,
      displayIcon: isMoreAvailable && !isDetailsCard,
      isActionVisible: true,
      ...action
    },
    CLEAR_SELECTION: {
      label: MY_EQP_SCHEMA.CLEAR_SELECTION,
      gaLabel: 'Clear Selection',
      classNames: isMultiCard && styles['contextualmenu-wrapper__list-item'],
      onClick: () => clearSelectionHandler(),
      gaContext: gaContextText,
      ...action
    },
    PLEASE_SELECT: {
      label: MY_EQP_SCHEMA.PLEASE_SELECT,
      gaLabel: 'Please Select',
      classNames: isMultiCard && styles['contextualmenu-wrapper__list-item'],
      onClick: () => selectedEquipmentHandler(),
      gaContext: gaContextText,
      ...action
    },
    CUST_EDIT: {
      label: MY_EQP_SCHEMA.EDIT,
      gaLabel: 'Edit',
      onClick: () => {
        editHandler('EDIT');
      },
      gaContext: gaContextText,
      isActionVisible: true,
      ...action
    },
    DELETE: {
      label: MY_EQP_SCHEMA.DELETE,
      gaLabel: 'Delete',
      icon: <CatIconTrash color="error" />,
      status: StatusType.error,
      onClick: () => {
        setModalOptions({ id: 'DELETE', isOpen: true });
      },
      gaContext: gaContextText,
      displayIcon: !isDesktop,
      isActionVisible: !equipmentDetails.isValidatedAsset,
      ...action
    },
    MORE: {
      label: MY_EQP_SCHEMA.LN_SEARCH_FACET_MORE,
      gaLabel: 'More',
      icon: <CatIconMenuDots size="lg" />,
      classNames: 'd-block mt-1 u-color--Black',
      moreOptions: [],
      gaContext: gaContextText,
      displayIcon: isMoreAvailable,
      isActionVisible: true,
      ...action
    }
  };

  if (action.id === MY_EQP_SCHEMA.MORE) {
    const filteredOptions = action.moreOptions.map((item) => {
      const key = item.id;
      if (menuActions[key]) {
        return {
          ...menuActions[key],
          ...item
        };
      }
    });
    menuActions.MORE = {
      ...menuActions.MORE,
      moreOptions: filteredOptions
    };
  }

  return menuActions?.[action.id];
}
